const styles = theme => ({
  customDomain__root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: 16,
  },
  embedInstructionText: {
    fontSize: '14px',
    fontWeight: 400,
    fontFamily: 'Inter',
  },
  badge: {
    display: 'flex',
    height: '20px',
    borderRadius: '5px',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '5px',
    marginTop: '3px',
    backgroundColor: '#9747ff14',
    padding: '0 8px',
  },
})

export default styles
